<template>
  <v-form
    ref="meshulamPaymentForm"
    onsubmit="return false;"
    v-if="consumer != null"
  >
    <v-layout row wrap class="justify-center">
      <v-flex xs12 md12>
        <div class="text-xs-center">
          <v-btn-toggle
            mandatory
            v-model="option"
            class="d-flex"
            @change="setPaymentOption"
          >
            <v-btn
              block
              color="primary"
              :class="[$vuetify.rtl ? 'mx-0' : '', 'white--text']"
              value="meshulam"
            >
              {{ $t('payment_gateway.meshulam.credit_card') }}
            </v-btn>

            <v-btn
              block
              color="primary"
              :class="[$vuetify.rtl ? 'mx-0' : '', 'white--text']"
              value="bit"
            >
              {{ $t('payment_gateway.meshulam.bit') }}
            </v-btn>
          </v-btn-toggle>
        </div>
      </v-flex>
    </v-layout>
    <div id="meshulam-container">
      <v-layout row wrap class="mt-3">
        <v-flex xs12>
          <!-- Phone -->
          <div class="pb-3">
            <VuePhoneNumberInput
              ref="Phone"
              class="custom-input"
              @update="setPhoneNumber"
              :no-example="true"
              :translations="Optionaltranslations"
              :show-code-on-list="true"
              :countries-height="30"
              :default-country-code="country_code"
              v-model="consumerPhone"
              :value="consumerPhone"
              size="lg"
              :dark="darkMode"
              :required="true"
              :only-countries="['IL']"
              color="#E53935"
            />
            <span
              v-bind:style="[!consumerPhone ? {color: 'red'} : {color: 'grey'}]"
              >{{ $t('payment_gateway.meshulam.phone_input.label') }}</span
            >
          </div>
        </v-flex>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <!-- First Name -->
            <v-text-field
              outline
              v-model="consumerName"
              :label="$t('payment_gateway.meshulam.first_name.label')"
              color="secondary"
              :rules="[
                rules.required,
                rules.min_length(3),
                rules.max_length(250),
              ]"
              counter="250"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 class="px-1">
            <!-- Last Name -->
            <v-text-field
              outline
              v-model="consumer_lastname"
              :label="$t('payment_gateway.meshulam.last_name.label')"
              color="secondary"
              :rules="[
                rules.required,
                rules.min_length(3),
                rules.max_length(250),
              ]"
              counter="250"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout row wrap class="justify-center">
        <v-flex xs12 md12>
          <div class="text-xs-center">
            <v-btn
              color="primary background--text"
              :class="[$vuetify.rtl ? 'mx-0' : '', 'white--text']"
              @click.stop="createPaymentProcess"
              :loading="loading"
              :disabled="
                loading ||
                  consumerPhone == null ||
                  consumerName == null ||
                  consumer_lastname == null
              "
              large
              >{{ $t('enrollment.steps.payment.button') }}
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="justify-center">
        <v-flex xs12 md12>
          <v-dialog v-model="dialogPaymentForm" width="0" height="0">
            <v-card>
              <v-card-text>
                <iframe
                  v-show="iframeSrc"
                  id="meshulam-ifrm"
                  :src="iframeSrc"
                  width="770"
                  height="625"
                ></iframe> </v-card-text
            ></v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </div>
  </v-form>
</template>
<script>
import {paymentActionClassifier} from '@/mixins/monetization.js';
import {mapGetters, mapState} from 'vuex';
import VuePhoneNumberInput from 'vue-phone-number-input';
import i18n from '@/i18n';
import rules from '@/validation';

export default {
  name: 'MeshulamPayment',
  props: [
    'pricing_id',
    'coupon_code',
    'price',
    'company',
    'event_type',
    'screener_id',
    'gateway',
  ],
  data() {
    return {
      rules,
      iframeSrc: null,
      complete: false,
      loading: false,
      dialogPaymentForm: false,
      purchase_id: null,
      Optionaltranslations: {
        countrySelectorLabel: i18n.t(
          'consumer.profile.label.country_code_selector'
        ),
        phoneNumberLabel: i18n.t('screening.register.lable.phone'),
      },
      formattedNumber: null,
      country_code: 'IL',
      consumer_lastname: null,
      meshulam_response: null,
      option: 'meshulam',
      consumerPhone: null,
      consumerName: null,
    };
  },
  components: {
    VuePhoneNumberInput,
  },
  mounted() {
    window.addEventListener('message', this.authenticationComplete, false);
    this.setPhoneAndName();
    if (!this.$refs.meshulamPaymentForm.validate()) {
      return false;
    }
    // this.$refs.Phone.$refs.PhoneNumberInput.$el.querySelector('input').focus();
  },
  beforeDestroy() {
    window.removeEventListener('message', function() {
      return;
    });
  },
  mixins: [paymentActionClassifier],
  computed: {
    ...mapState({
      consumer: (state) => state.consumer.profile,
    }),
    ...mapGetters('app', {
      darkMode: 'darkMode',
    }),
    ...mapGetters('affiliation', {
      affiliation: 'get',
    }),
  },

  methods: {
    setPaymentOption(value) {
      this.option = value;
    },
    setPhoneAndName() {
      let cloneConsumer = JSON.parse(JSON.stringify(this.consumer.phone));
      if (
        !cloneConsumer ||
        (cloneConsumer && !cloneConsumer.startsWith('+972'))
      ) {
        this.consumerPhone = null;
      } else {
        this.consumerPhone = cloneConsumer;
      }

      this.consumerName = !this.consumer.name
        ? null
        : Object.assign(this.consumer.name);
    },

    setPhoneNumber(payload) {
      if (payload.formattedNumber) {
        this.formattedNumber = payload.formattedNumber;
        this.complete = true;
      }
    },

    async authenticationComplete(result) {
      if (
        result.origin === 'https://secure.meshulam.co.il' ||
        result.origin === 'https://sandbox.meshulam.co.il'
      ) {
        this.meshulam_response = result;
        return;
      }

      if (result.data != '3DS-authentication-complete' || !this.purchase_id) {
        return;
      }

      try {
        this.dialogPaymentForm = false;
        this.loading = true;
        //console.log(this.meshulam_response)
        switch (this.meshulam_response.data.action) {
          case 'close': {
            this.failed();
            break;
          }
          case 'payment': {
            if (this.meshulam_response.data.status == 1) {
              let result = await this.$store.dispatch(
                'consumer/markPurchaseProcessing',
                {purchase_id: this.purchase_id}
              );
              this.success(result);
            }
            break;
          }
          case 'bit_payment': {
            if (this.meshulam_response.data.status == 1) {
              let result = await this.$store.dispatch(
                'consumer/markPurchaseProcessing',
                {purchase_id: this.purchase_id}
              );
              this.success(result);
            }
            break;
          }
          case 'failed_to_load_page': {
            this.failed();
            break;
          }
          case 'bit_cancel': {
            this.failed();
            break;
          }
          default: {
            console.log(this.meshulam_response);
            this.failed();
          }
        }
      } catch (error) {
        this.iframeSrc = null;
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      } finally {
        this.loading = false;
        this.iframeSrc = null;
        this.reset();
      }
    },

    async _preparePayload() {
      /* Create event type based payload */
      var payload = {};

      payload.charge_type = 'meshulam';
      payload.success_url = `${this.company.domain}/payment/returnUrl`;
      payload.cancel_url = `${this.company.domain}/payment/returnUrl`;
      payload.coupon_code = this.coupon_code;
      payload.is_bit = this.option == 'bit' ? true : false;
      payload.phone = this.formattedNumber;
      payload.name = this.consumerName + ' ' + this.consumer_lastname;

      // Setting affiliation if found
      payload.affiliation = this.affiliation;

      switch (this.event_type) {
        case this.DEFINES.SCREENER_TYPE_VALUE.VIRTUAL:
          payload.pricing_id = this.pricing_id;
          break;
        case this.DEFINES.SCREENER_TYPE_VALUE.PHYSICAL:
          payload.screener_id = this.screener_id;
          break;
        default:
          break;
      }
      return payload;
    },

    async createPaymentProcess() {
      if (!this.$refs.meshulamPaymentForm.validate()) {
        return false;
      }

      if (!this.formattedNumber.startsWith('+972')) {
        this.$store.dispatch('app/showMessage', {
          message: i18n.t('payment.meshulam.error_acts_in_israel_only'),
          color: 'error',
        });
        return false;
      }

      this.loading = true;
      this.complete = false;
      const payload = await this._preparePayload();
      const action = this._moduleWithAction();

      try {
        let response = await this.$store.dispatch(action, payload);
        this.iframeSrc = response.purchase.payment_details.url;
        this.purchase_id = response.purchase.id;
        this.dialogPaymentForm = true;
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      } finally {
        this.loading = false;
      }
    },

    async success(response = {}) {
      response.customMessage = this.$t('screener.payment_message_meshulam');
      this.$emit('success', response);
    },

    failed(error = {}) {
      this.$emit('failed', error);
    },

    reset() {
      this.purchase_id = null;
      this.$emit('reset');
    },
  },
};
</script>
<style>
#meshulam-ifrm {
  z-index: 100;
  width: 100%;
  height: 100%;
  position: fixed;
  border: 0;
  top: 0;
  right: 0;
  background-color: transparent !important;
}
</style>
